package content

import react.*
import react.dom.br
import react.dom.li
import react.dom.p
import styled.*


val aboutThisPageContent =  fc<Props>("AboutThisPageContent") {
    styledH1 {
        css {
            +BaseLayoutStyles.noMarginNoPaddingNoBorders
        }
        +"Über diese Seite"
    }
    styledDiv {
        css {
            +BaseLayoutStyles.noMarginNoPaddingNoBorders
            +BaseLayoutStyles.alignTextLeft
//            +BaseLayoutStyles.dottedBorder1px
        }
        p {
            +"Diese Internetseite ist mit Kotlin™/React mit dem JVM IR compiler erstellt. "
            +"Sie dient als Testfeld für den Einsatz von Technologien. "
            +"In späteren überarbeitungen wird wahrscheinlich Kotlin/Wasm oder Kotlin Multiplatform Compose evaluiert."
        }
        p {
            +"Eine Einführung wie eine Internetseite mit Hilfe von Kotlin/React erstellt werden kann, finden Sie auf: "
            br{}
            styledA {
                attrs.href = "https://play.kotlinlang.org/hands-on/overview"
                attrs.target = "_blank"
                attrs.text("https://play.kotlinlang.org/hands-on/overview")
            }
        }
        p{
            +"Im einzelnen wurden folgende Technologien und Libraries verwendet: "
            val kotlinReactVersion = "2025.8.16-19.1.1"
            val styledNextVersion = "2025.8.16"
            val kotlinVersion = "2.2.0"

            styledUl {
                li {
                    +"Kotlin: $kotlinVersion"
                }
                li {
                    +"Kotlin Multiplatform: $kotlinVersion"
                }
                li {
                    +"Kotlin plugin serialization: $kotlinVersion"
                }
                li {
                    +"kotlin-react: $kotlinReactVersion"
                }
                li {
                    +"kotlin-react-dom: $kotlinReactVersion"
                }
                li {
                    +"kotlin-styled-next: $styledNextVersion"
                }
                li {
                    +"chart.js: 4.4.4"
                }
                li {
                    +"react-chartjs-2: 5.3.0"
                }
                li {
                    +"react-use: 17.6.0"
                }
                li {
                    +"three.js: 0.180.0"
                }
            }
        }
        p{
            +"Sollten Sie Interesse an den gemachten Erfahrungen haben, so wenden Sie sich bitte an uns."
        }
        styledP{
            css {
//                +BaseLayoutStyles.solidBorder1px
            }
            +"Wir helfen Ihnen gerne."
        }
    }
}
